<template>
  <div class="service-over-view">
    <div class="service-over-view-line" style="height: 280px;align-items: center">
      <div style="width: 40%;border: 1px solid #DCDFE6;box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);padding: 10px 0;">
        <common-ring commonRingId="serviceRing" :height="'260px'" :colorList="serviceColorList" :ringLegend="serviceRingLegend" :ringTitle='serviceTitle' :ringData='serviceInfo' />
      </div>
<!--      <div class="service-person-count-box">-->
<!--        <div class="service-person-count">{{valueaddVenueCount}}</div>-->
<!--        <div class="service-person-tip">预约次数</div>-->
<!--      </div>-->
<!--      <div class="service-person-count-box">-->
<!--        <div class="service-person-count">{{valueaddVenueMoney}}</div>-->
<!--        <div class="service-person-tip">总金额</div>-->
<!--      </div>-->
      <div class="service-person-count-box" style="background:linear-gradient(#12C9E4, #12C9E499);">
        <i class="el-icon-damai-yuyue1"></i>
        <div class="service-person-count-box-info">
          <div class="service-person-count">{{valueaddVenueCount}}</div>
          <div class="service-person-tip">预约次数</div>
        </div>
      </div>
      <div class="service-person-count-box" style="background:linear-gradient(#1DCBBB, #1DCBBB99);">
        <i class="el-icon-damai-yingshoujine"></i>
        <div class="service-person-count-box-info">
          <div class="service-person-count">{{valueaddVenueMoney}}</div>
          <div class="service-person-tip">总金额</div>
        </div>
      </div>
    </div>

    <div class="finance-over-view-line" style="height: 280px;margin: 60px 0 20px 0;padding: 10px;position: relative;border: 1px solid #DCDFE6;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);">
      <chart-time-select @getData="getValueaddStatistics" />
      <common-line style="z-index: 1000" lineId='serviceAccessRecordLine' :height='"260px"' :lineTitle='serviceAccessRecordTitle' :legendData="serviceAccessRecordLegendData" :xAxis="serviceAccessRecordXAxis" :yAxis='serviceAccessRecordYAxis' :series='serviceAccessRecordSeries' />
    </div>

  </div>

</template>

<script>
  import CommonRing from '../../../components/Echarts/Pie/Pie/commonRing'
  import {api} from '../../api/ValueAdded'
  import {errorHandler} from '../../../utils/errorHandler'
  import CommonLine from '../../../components/Echarts/Line/commonLine'
  import ChartTimeSelect from "../../../components/Echarts/ChartTimeSelect/ChartTimeSelect";

  export default {
    components: {
      ChartTimeSelect,
      CommonLine,
      CommonRing},
    name: 'service-over-view',
    data () {
      return {
        serviceColorList: ['#5B9BD5', '#ED7D31', '#C2A753', '#4BB66E', '#FFA336', '#53A5BC', '#47C4CA', '#77E5BF', '#82D74C', '#A4C344'],
        serviceRingLegend: {
          left: 'center',
          bottom: -5,
        },
        serviceTitle: '预约次数',
        serviceInfo: [],

        valueaddVenueMoney: 0,
        valueaddVenueCount: 0,

        serviceAccessRecordRadio: false,
        serviceAccessRecordTitle: '预约统计',
        serviceAccessRecordLegendData: [],
        serviceAccessRecordXAxis: {
          type: 'category',
          name: '日期',
          data: []
        },
        serviceAccessRecordYAxis: [
          {
            type: 'value',
            name: '金额/元',
            splitLine: {
              show: false
            },
          }
        ],
        serviceAccessRecordSeries: [],

      }
    },
    mounted () {
      this.getValueaddVenueRecordStatistics()
    },
    methods: {
      getValueaddVenueRecordStatistics () {
        this.$axios.get(api.getValueaddVenueRecordStatistics, {})
          .then(res => {
            let data = res.data.data
            this.valueaddVenueMoney = data.valueaddVenueMoney
            this.valueaddVenueCount = data.valueaddVenueCount
            let serviceInfo = []
            for (let i in data.map) {
              let serviceObj = {
                name: i,
                value: data.map[i]
              }
              serviceInfo.push(serviceObj)
            }
            this.serviceInfo = serviceInfo
          })
          .catch(errorHandler('获取数据失败'))
      },

      getValueaddStatistics (type, startTime, endTime) {
        this.$axios.post(`${api.getValueaddStatistics}`, {
          startTime: startTime || '',
          endTime: endTime || '',
          timeType: type || 'DAY'
        })
          .then(res => {
			      let data = res.data.data
            let xData = []
            let seriesData = []
            data.map(v => {
              seriesData.push(v.valueaddTotalMoney)
              if (type === 1) {
                let dateArr = v.time.split('-')
                let showData = `${dateArr[1]}-${dateArr[2]}`
                xData.push(showData)
              } else {
                xData.push(v.time)
              }
            })
            this.serviceAccessRecordXAxis.data = xData
            this.serviceAccessRecordSeries = [
              {
                name: '',
                type: 'line',
                stack: '总量',
                // areaStyle: {},
                smooth:true,
                symbol: 'circle',
                symbolSize: 5,
                sampling: 'average',
                itemStyle: {
                  color: '#00A0E6'
                },
                areaStyle: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#00A0E6'
                  }, {
                    offset: 1,
                    color: '#ffe'
                  }])
                },
                data: seriesData
              },

            ]
          })
          .catch(errorHandler('获取数据失败'))
      },

    },
    watch: {}

  }
</script>


<style lang="less">
  .service-over-view {
    padding: 20px 2%;
    .service-over-view-line {
      display: flex;
      justify-content: space-between;
      .service-person-count-box {
        width: 400px;
        height: 160px;
        padding: 10px 10px;
        border-radius: 10px;
        color: #ffffff;
        background-color: #00A0E6;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border: 1px solid #DCDFE6;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);
        i {
          width: 30%;
          font-size: 48px;
        }
        .service-person-count-box-info {
          width: 70%;
          text-align: left;
          .service-person-count {
            font-size: 36px;
            font-weight: 600;
            word-wrap:break-word;
          }
          .service-person-tip {
            font-size: 16px;
          }
        }
      }
      .service-over-view-line-left {
        width: 49%;
        padding: 10px 10px;
        border: 1px solid #eeeeee;
        border-radius: 10px;
        display: flex;
        justify-content: space-between;
        overflow: hidden;
      }
      .service-over-view-line-right {
        width: 49%;
        padding: 10px 10px;
        border: 1px solid #eeeeee;
        border-radius: 10px;
        overflow: hidden;
      }

      .el-table {
        thead {
          th {
            padding: 6px 0;
            text-align: center;
            color: #666666;
            background-color: #eff1f5;
          }
        }
        tbody {
          td {
            padding: 6px 0;
            text-align: center;
            color: #FF0000;
          }
        }
      }

      .el-pagination {
        padding: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/ValueAddedService/ServiceOverView/ServiceOverView.vue